<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-8.18,802.5l-1.32-1.32l4.94-4.94h-2.42v-1.87h5.6v5.6h-1.87v-2.41L-8.18,802.5L-8.18,802.5z M5.44,798.76l-11.21-11.21
	l1.32-1.32l11.21,11.2L5.44,798.76L5.44,798.76z M7.97,790.63h-5.6v-5.6h1.87v2.41l4.94-4.94l1.32,1.32l-4.94,4.94h2.42V790.63
	L7.97,790.63z"/>
</svg>

</template>